import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { CONTACT } from "@/data/site";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Motion";

export const CTABand = ({ title = "Ready to move forward with confidence?", id = "page" }) => (
  <section className="section-padding bg-brand-navy text-white" data-testid={`${id}-cta-section`}>
    <div className="section-shell">
      <Reveal className="grid items-end gap-10 lg:grid-cols-[1fr_auto]">
        <div>
          <p className="overline mb-5 text-brand-copper">Schedule an Immigration Consultation</p>
          <h2 className="max-w-3xl font-serif text-3xl font-bold leading-tight sm:text-4xl lg:text-5xl">{title}</h2>
          <p className="mt-5 max-w-2xl text-base leading-8 text-white/70">
            Bring your questions, notices, and documents. We will help you understand the process and organize your next step.
          </p>
        </div>
        <div className="flex flex-col gap-4 sm:flex-row lg:flex-col">
          <Button asChild size="lg" className="rounded-full bg-brand-copper px-8 text-brand-navy hover:bg-brand-copper/90">
            <Link to="/contact" data-testid={`${id}-schedule-cta`}>
              Schedule Consultation <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="rounded-full border-white/25 bg-transparent px-8 text-white hover:bg-white hover:text-brand-navy">
            <a href={CONTACT.phoneHref} data-testid={`${id}-call-cta`}>
              <Phone className="h-4 w-4" /> Call Our Office
            </a>
          </Button>
        </div>
      </Reveal>
    </div>
  </section>
);
